import { Box, styled } from '@mui/material';
import { EntityValues } from './entity-values';
import { formatConditionsText, formatEntityType } from './utils';
import { AndBlockValues } from '../../../workflow-sidebar/edit-node-form/nodes/enroll-node-editor/enroll-node-editor.types';

type AndBlockViewerProps = {
  andBlock: AndBlockValues;
  isLast: boolean;
};

export const AndBlockViewer = ({ andBlock, isLast }: AndBlockViewerProps) => {
  return (
    <Box>
      <AndContentWrapper>
        <Row>
          <RowText>{formatEntityType(andBlock.entityType)}</RowText>
          <RowText>{formatConditionsText(andBlock.condition)}</RowText>
        </Row>
        <EntityValues entityType={andBlock.entityType} entityId={andBlock.entityId} />
      </AndContentWrapper>
      {!isLast && <LogicalOperatorWrapper>AND</LogicalOperatorWrapper>}
    </Box>
  );
};

const AndContentWrapper = styled(Box)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  flexWrap: 'wrap',
  gap: theme.spacing(1),
  padding: theme.spacing(1),
}));

const Row = styled(Box)(({ theme }) => ({
  display: 'inline-flex',
  alignItems: 'center',
  gap: theme.spacing(1),
}));

const RowText = styled('span')(() => ({
  fontSize: '10px',
}));

const LogicalOperatorWrapper = styled(Box)(({ theme }) => ({
  textAlign: 'center',
  fontSize: '10px',
  color: theme.palette.lwBlack[100],
  backgroundColor: theme.palette.grey[100],
}));
